import { axios } from '@/utils/axios';

export const generateBridgeSecret = () => {
  return axios.get('/api/test/generate-bridge-secret');
}

export const postBridgeSecret = (data: postBridgeSecretRequest) => {
    return axios.post('/api/registration/bridge', data, {
        headers: {
            'Content-Type': 'application/json',
        },
    });
}

export const setBridgePassword = (data: setPasswordForm) => {
    return axios.post('/api/registration/bridge/set-password', data, {
        headers: {
            'Content-Type': 'application/json',
        },
    });
}